import { useMutation } from '@tanstack/react-query';
import qs from 'qs';

import {
  SuspenseQueryOption,
  useSuspendedQuery,
  useZepApiClient,
  UseZepApiMutationOptions,
} from '@zep/apis';
import { ChargeZemItem, Currency } from '@zep/types';

/**
 * @deprecated API type 마이그레이션이 필요합니다. README의 API Type Safety 가이드를 참고하세요: docs/api-type-safety.md
 */
export const useChargeZemInfo = (
  options?: UseZepApiMutationOptions<
    {
      status: number;
      statusKey: string;
      data: { orderId: string };
    },
    { id: number }
  >,
) => {
  const client = useZepApiClient();
  return useMutation(
    ['zem-item-info'],
    async ({ id }) => {
      const { data } = await client.get(`v2/cash/buy/info`, {
        params: {
          id,
        },
        headers: {
          Accept:
            'text/html, application/xhtml+xml, application/xml;q=0.9, */*;q=0.8',
        },
      });
      return data;
    },
    options,
  );
};

/**
 * @deprecated API type 마이그레이션이 필요합니다. README의 API Type Safety 가이드를 참고하세요: docs/api-type-safety.md
 */
export const useChargeZemItems = (
  options?: SuspenseQueryOption<{ status: number; data: ChargeZemItem[] }>,
) => {
  const client = useZepApiClient();
  return useSuspendedQuery(
    ['zem-items'] as string[],
    async () => {
      const { data } = await client.get('/v2/cash');

      return data;
    },
    options,
  );
};

/**
 * @deprecated API type 마이그레이션이 필요합니다. README의 API Type Safety 가이드를 참고하세요: docs/api-type-safety.md
 */
export const useChargeZemResult = (
  orderId: string,
  options?: SuspenseQueryOption<{
    status: number;
    data: {
      status: number;
      pgStatus: 0;
      reason: string;
      orderId: string;
      productName: string;
      productQuantity: number | string;
      baseZem?: number;
      bonusZem?: number;
      totalZem?: number;
      promotionRateBps?: number;
      promotionType?: string;
      promotionCode?: string;
      amount: number;
      currency: Currency;
      paymentMethod: string;
      purchasedAt: string;
    };
  }>,
) => {
  const client = useZepApiClient();
  return useSuspendedQuery(
    ['zem-item-result', orderId] as string[],
    async () => {
      const { data } = await client.get('/v2/cash/buy/result', {
        params: {
          orderId,
        },
      });
      return data;
    },
    options,
  );
};

export const API_V2_CASH_BUY_PAYPLE_CALLBACK = `${process.env.NEXT_PUBLIC_BASE_URL}/api/v2/cash/buy/payple/callback`;
export const API_V2_CASH_BUY_TOSS_CALLBACK_SUCCESS = `${process.env.NEXT_PUBLIC_BASE_URL}/api/v2/cash/buy/toss/callback/success`;

export const getCashBuyFailCallbackUrl = (args: Record<string, any>) => {
  return `${
    process.env.NEXT_PUBLIC_WEB_URL
  }/accounts/charge/fail?${qs.stringify({
    ...args,
  })}`;
};
